import { useState } from "react";
import * as React from "react";
import { useDeleteProductCategory } from "~/apps/pos/apis/productCategories";
import { ProductSegment } from "~/apps/pos/models";
import { DeleteConfirmOverlay } from "~/apps/pos/admin/components/shared/DeleteConfirmOverlay";

export const useProductCategoryDeleteConfirm = () => {
  const [deleteItem, setDeleteItem] = useState<ProductSegment | undefined>(undefined);
  const { mutate: onDelete, isLoading, error } = useDeleteProductCategory();

  const handleClose = () => setDeleteItem(undefined);

  const handleDelete = () => {
    if (!deleteItem?.id) return;
    onDelete(deleteItem.id, {
      onSuccess: () => {
        handleClose();
      },
    });
  };

  const deleteConfirm = deleteItem ? (
    <DeleteConfirmOverlay
      headTitle={"Delete category!"}
      itemName={deleteItem.name}
      isLoading={isLoading}
      error={error?.message || error?.errorMessage || ""}
      onClose={handleClose}
      onDelete={handleDelete}
    />
  ) : null;

  return {
    deleteConfirm,
    showDeleteConfirm: setDeleteItem,
  };
};
